import { Icon } from "@mui/material";
import { Link } from "react-router-dom";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

export function SidenavItem({ route, icon, name, miniSidenav }) {
    if (!route) return null;
    return (
        <Link to={route}>
            <VuiBox sx={({ breakpoints }) => ({
                padding: "11px 20px 13px",
                display: "flex",
                gap: "16px",
                alignItems: "center",
                cursor: "pointer",
                justifyContent: miniSidenav ? "center" : "flex-start",
                [breakpoints.down("lg")]: {
                    justifyContent: miniSidenav ? "flex-start" : "center",
                }
            })}>
                <VuiBox sx={{
                    backgroundColor: "red",
                    minWidth: "32px",
                    width: "32px",
                    height: "32px",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#1A1F37",
                }}>
                    <Icon component="i" sx={{
                        marginRight: "0px",
                        color: "#007CFF",
                        fontSize: "14px",
                    }}>
                        {icon}
                    </Icon>
                </VuiBox>
                <VuiTypography sx={({ breakpoints }) => ({
                    color: "#FFFFFF",
                    fontSize: "16px",
                    fontWeight: "500",
                    [breakpoints.down("lg")]: {
                        display: miniSidenav ? "block" : "none",
                    },
                    [breakpoints.up("lg")]: {
                        display: miniSidenav ? "none" : "block",
                    },
                })}>{name}</VuiTypography>
            </VuiBox>
        </Link>
    )
}